
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jsyvA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Ynul = parcelRequire("2Ynul");

// implements the FlagProvider typescript interface from '@atlassian/connect-module-core'
class $5b38bdb59f96dd8e$export$b0063bae72b769ca {
    constructor({ showFlag: showFlag, hideFlag: hideFlag }){
        this.create = ({ body: description, actions: actions, ...options })=>{
            this.showFlag({
                ...options,
                description: description,
                actions: actions.map((action)=>({
                        key: action.actionKey,
                        content: action.actionText,
                        onClick: action.executeAction
                    })),
                onClose: ()=>{
                    options.onClose(options.id);
                }
            });
            return {
                flagId: options.id,
                close: ()=>{
                    this.hideFlag(options.id);
                }
            };
        };
        this.showFlag = showFlag;
        this.hideFlag = hideFlag;
    }
}

// implements the MessageProvider typescript interface from '@atlassian/connect-module-core'
// the messages module is deprecated but it maps well enough to flags to just do that
class $157238e938dfefde$export$a83e9a931c6e6660 {
    constructor({ showFlag: showFlag, hideFlag: hideFlag }){
        this._createMessageType = (type)=>(title, description, options)=>{
                const { id: id } = this.showFlag({
                    type: type,
                    title: title,
                    description: description,
                    actions: [],
                    close: options.fadeout ? 'auto' : 'manual',
                    onClose: ()=>{
                        const flag = this.messageIDs[options.id];
                        if (typeof flag.onClose === 'function') flag.onClose();
                        delete this.messageIDs[options.id];
                    }
                });
                this.messageIDs[options.id] = {
                    id: id
                };
            };
        // ADG3 only supports success, error, warning, and info,
        // the others can safely map to info
        this.error = this._createMessageType('error');
        this.generic = this._createMessageType('info');
        this.hint = this._createMessageType('info');
        this.info = this._createMessageType('info');
        this.success = this._createMessageType('success');
        this.warning = this._createMessageType('warning');
        this.clear = (id)=>{
            const flag = this.messageIDs[id];
            if (flag) {
                this.hideFlag(flag.id);
                delete this.messageIDs[id];
            }
        };
        this.onClose = (id, callback)=>{
            const flag = this.messageIDs[id];
            if (flag) flag.onClose = callback;
        };
        this.showFlag = showFlag;
        this.hideFlag = hideFlag;
        this.messageIDs = {};
    }
}



var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $80koo = parcelRequire("80koo");


var $1UApO = parcelRequire("1UApO");


var $8cOoD = parcelRequire("8cOoD");





var $f7B1p = parcelRequire("f7B1p");

const $c3a4fd1273bb47ee$var$parseFetchResponse = (response)=>response.json().then((json)=>({
            json: json,
            status: response.status,
            statusText: response.statusText,
            ok: response.ok
        }));
const $c3a4fd1273bb47ee$export$cac04457d61afcbc = ({ cloudId: cloudId, connectHost: connectHost })=>{
    (0, $42omo.useEffect)(()=>{
        const analyticsModule = {
            addonKey: 'com.addonengine.analytics',
            fetchStargate: (path, init)=>{
                const resource = `/gateway/api/ex/confluence/${cloudId}/analytics${path}`;
                // eslint-disable-next-line check-credentials-option/has-credentials-option
                return (0, $f7B1p.cfetch)(resource, init).then($c3a4fd1273bb47ee$var$parseFetchResponse);
            },
            getIconData: (resource)=>{
                // eslint-disable-next-line check-credentials-option/has-credentials-option
                return (0, $f7B1p.cfetch)(resource, {
                    credentials: 'same-origin'
                }).then((response)=>response.blob().then((blob)=>new Promise((resolve, reject)=>{
                            const reader = new window.FileReader();
                            reader.onload = ()=>resolve(reader.result);
                            reader.onerror = reject;
                            reader.readAsDataURL(blob);
                        })));
            },
            fetchQuery: (path, init)=>{
                // eslint-disable-next-line check-credentials-option/has-credentials-option
                return (0, $f7B1p.cfetch)(path, init).then($c3a4fd1273bb47ee$var$parseFetchResponse);
            }
        };
        analyticsModule.fetchStargate.returnsPromise = true;
        analyticsModule.fetchStargate.preserveNullProperties = true;
        analyticsModule.getIconData.returnsPromise = true;
        analyticsModule.fetchQuery.returnsPromise = true;
        analyticsModule.fetchQuery.preserveNullProperties = true;
        connectHost.defineModule('analytics', analyticsModule);
    }, [
        cloudId,
        connectHost
    ]);
    return null;
};






var $koRMW = parcelRequire("koRMW");


var $5ZqQS = parcelRequire("5ZqQS");

const $042d81536d760f84$var$contextPathFromPathname = window.location && window.location.pathname.split('/')[1];
const $042d81536d760f84$export$8c6bf2df244e6a99 = $042d81536d760f84$var$contextPathFromPathname ? `/${$042d81536d760f84$var$contextPathFromPathname}` : '/wiki';
const $042d81536d760f84$export$5cf2450969d5ce3b = ({ cloudId: cloudId })=>{
    (0, $42omo.useEffect)(()=>{
        try {
            const marketplaceModule = (0, $koRMW.default)({
                product: 'confluence',
                cloudId: cloudId,
                environment: window.location.host.indexOf('.jira-dev.com') !== -1 ? 'staging' : window.location.host.indexOf('.atlassian.net') !== -1 ? 'prod' : 'unknown',
                baseUrl: `${window.location.protocol}//${window.location.host}${$042d81536d760f84$export$8c6bf2df244e6a99}`,
                gqlGatewayUrl: `${window.location.protocol}//${window.location.host}/gateway/api/graphql`
            });
            if (window.define) window.define('ac/marketplace', marketplaceModule);
        } catch (error) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: 'ecosystem'
            });
        }
    }, [
        cloudId
    ]);
    return null;
};



var $04e9M = parcelRequire("04e9M");


var $6UqI3 = parcelRequire("6UqI3");

/**
 * Determines whether a sampled event should be sent based on given rate.
 * @param {int} rate Rate as an integer percentage.
 * @returns {boolean}
 */ const $f6a89b004ca35d15$export$4071f596f7ad546d = (rate)=>{
    return Math.random() * 100 < rate;
};
const $f6a89b004ca35d15$export$ebe53b1f72f5d27a = 10;


function $9ecdd307d90af869$var$_isCacheable(extension) {
    const href = extension.url;
    return href !== undefined && href.indexOf('xdm_e=') === -1;
}
function $9ecdd307d90af869$var$_getModuleType(extension) {
    return extension.options ? extension.options.moduleType : undefined;
}
function $9ecdd307d90af869$var$_getModuleLocation(extension) {
    return extension.options ? extension.options.moduleLocation : undefined;
}
function $9ecdd307d90af869$var$_getPearApp(extension) {
    return extension.options && extension.options.pearApp === 'true';
}
function $9ecdd307d90af869$var$_getContentId(extension) {
    return extension.options && extension.options.productContext ? extension.options.productContext['content.id'] : undefined;
}
function $9ecdd307d90af869$var$_getContentType(extension) {
    return extension.options && extension.options.productContext ? extension.options.productContext['content.type'] : undefined;
}
function $9ecdd307d90af869$var$_getSpaceId(extension) {
    return extension.options && extension.options.productContext ? extension.options.productContext['space.id'] : undefined;
}
function $9ecdd307d90af869$var$_getSpaceKey(extension) {
    return extension.options && extension.options.productContext ? extension.options.productContext['space.key'] : undefined;
}
function $9ecdd307d90af869$var$pickAttributes(extension) {
    return {
        moduleType: $9ecdd307d90af869$var$_getModuleType(extension),
        iframeIsCacheable: $9ecdd307d90af869$var$_isCacheable(extension),
        moduleKey: extension.key,
        moduleLocation: $9ecdd307d90af869$var$_getModuleLocation(extension),
        pearApp: $9ecdd307d90af869$var$_getPearApp(extension)
    };
}
function $9ecdd307d90af869$var$buildAppAnalyticsEvent(activationId, extension) {
    const moduleType = $9ecdd307d90af869$var$_getModuleType(extension);
    const event = {
        action: 'invoked',
        actionSubject: 'connectAddon',
        actionSubjectId: extension.addon_key,
        source: moduleType,
        attributes: {
            activationId: activationId,
            appId: extension.addon_key,
            moduleType: moduleType,
            moduleKey: extension.key
        }
    };
    const spaceId = $9ecdd307d90af869$var$_getSpaceId(extension);
    if (spaceId) {
        event.attributes.spaceId = spaceId;
        event.attributes.spaceType = (0, $6UqI3.getSpaceType)($9ecdd307d90af869$var$_getSpaceKey(extension));
        event.containerType = 'space';
        event.containerId = spaceId;
        const contentId = $9ecdd307d90af869$var$_getContentId(extension);
        if (contentId) {
            event.objectType = $9ecdd307d90af869$var$_getContentType(extension);
            event.objectId = contentId;
        }
    }
    return event;
}
const $9ecdd307d90af869$export$32b5fc7c31e23507 = new class ConnectAnalyticsPublishSupport {
    async trackIframePerformanceTelemetry(extension, metrics) {
        const analyticsWebClient = await (0, $04e9M.getAnalyticsWebClient)();
        analyticsWebClient.sendOperationalEvent({
            source: extension.addon_key,
            action: 'iframeRendered',
            actionSubject: 'connectAddon',
            actionSubjectId: extension.addon_key,
            attributes: Object.assign({
                domainLookupTime: metrics.domainLookupTime,
                connectionTime: metrics.connectionTime,
                decodedBodySize: metrics.decodedBodySize,
                domContentLoadedTime: metrics.domContentLoadedTime,
                fetchTime: metrics.fetchTime
            }, $9ecdd307d90af869$var$pickAttributes(extension))
        });
    }
    async trackIframeLoaded(extension) {
        const analyticsWebClient = await (0, $04e9M.getAnalyticsWebClient)();
        analyticsWebClient.sendOperationalEvent({
            action: 'iframeLoaded',
            actionSubject: 'connectAddon',
            actionSubjectId: extension['addon_key'],
            attributes: $9ecdd307d90af869$var$pickAttributes(extension),
            source: extension.addon_key
        });
    }
    async trackIframeTimeout(extension) {
        const analyticsWebClient = await (0, $04e9M.getAnalyticsWebClient)();
        analyticsWebClient.sendOperationalEvent({
            action: 'iframeTimeout',
            actionSubject: 'connectAddon',
            actionSubjectId: extension['addon_key'],
            attributes: $9ecdd307d90af869$var$pickAttributes(extension),
            source: extension.addon_key
        });
    }
    async trackInvalidIframeTimeout(extension) {
        const analyticsWebClient = await (0, $04e9M.getAnalyticsWebClient)();
        analyticsWebClient.sendOperationalEvent({
            action: 'iframeInvalidTimeout',
            actionSubject: 'connectAddon',
            actionSubjectId: extension['addon_key'],
            attributes: $9ecdd307d90af869$var$pickAttributes(extension),
            source: extension.addon_key
        });
    }
    async trackIframeViewed(extension) {
        const analyticsWebClient = await (0, $04e9M.getAnalyticsWebClient)();
        analyticsWebClient.sendOperationalEvent({
            action: 'iframeViewed',
            actionSubject: 'connectAddon',
            actionSubjectId: extension['addon_key'],
            attributes: $9ecdd307d90af869$var$pickAttributes(extension),
            source: extension.addon_key
        });
    }
    async trackContentResolverEvent(eventData) {
        const analyticsWebClient = await (0, $04e9M.getAnalyticsWebClient)();
        const { success: success, extra: extra } = eventData;
        const action = success ? 'contentResolverSucceeded' : 'contentResolverFailed';
        const { extension: extension, attrs: attrs } = extra;
        const { moduleType: moduleType, moduleKey: moduleKey, moduleLocation: moduleLocation, pearApp: pearApp } = $9ecdd307d90af869$var$pickAttributes(extension);
        const attributes = {
            ...attrs,
            moduleType: moduleType,
            moduleKey: moduleKey,
            moduleLocation: moduleLocation,
            pearApp: pearApp
        };
        if ((0, $f6a89b004ca35d15$export$4071f596f7ad546d)((0, $f6a89b004ca35d15$export$ebe53b1f72f5d27a))) analyticsWebClient.sendOperationalEvent({
            action: action,
            actionSubject: 'connectAddon',
            actionSubjectId: extension.addon_key,
            attributes: attributes,
            source: extension.addon_key
        });
    }
    async sendAppAnalyticsEvent(activationId, extension) {
        const analyticsWebClient = await (0, $04e9M.getAnalyticsWebClient)();
        const event = $9ecdd307d90af869$var$buildAppAnalyticsEvent(activationId, extension);
        analyticsWebClient.sendTrackEvent(event);
    }
    async handleForwardedAnalyticsEvent(type, event) {
        const analyticsWebClient = await (0, $04e9M.getAnalyticsWebClient)();
        switch(type){
            case 'ui':
                analyticsWebClient.sendUIEvent(event);
                break;
            case 'operational':
                analyticsWebClient.sendOperationalEvent(event);
                break;
            case 'track':
                analyticsWebClient.sendTrackEvent(event);
                break;
            case 'screen':
                analyticsWebClient.sendScreenEvent(event);
                break;
            default:
                // eslint-disable-next-line no-console
                console.error(`Unknown event type forwarded from ConnectHost: ${type}`);
        }
    }
}();


function $e8b0a10921c7b2d5$export$c696ad8ee2dce236(iframeId) {
    return Boolean(document.getElementById(iframeId));
}


const $824b1085c7d6a070$var$ConnectSupportComponent = ({ flags: flags })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    // For Confluence App Analytics. This code works in conjunction with monolith's
    // confluence-plugins/confluence-bundled-plugins/atlassian-connect/jsapi-v5/src/main/resources/v5/velocity/iframe-body-script.vm.
    // It adds a listener to the initial HTML page that stores events if this ConnectSupport component has not mounted yet.
    // Here, we process the missed event data and disable the initial listener.
    (0, $42omo.useEffect)(()=>{
        window.__CONFLUENCE_CONNECT_SUPPORT_LOADED__ = true;
        // We're not using the CFE provided @confluence/storage-manager because
        // this package is not available in the monolith.
        const events = JSON.parse(window.localStorage.getItem((0, $1UApO.keys).CONNECT_APP_ANALYTICS) || `""`) || [];
        events.forEach((e)=>{
            (0, $9ecdd307d90af869$export$32b5fc7c31e23507).sendAppAnalyticsEvent(activationId, e['extension']);
        });
        window.localStorage.removeItem((0, $1UApO.keys).CONNECT_APP_ANALYTICS);
    }, [
        activationId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $80koo.RequireLegacyWRM), {
        wrm: [
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ]
    }, ()=>{
        if (!window.connectHost) return null;
        const connectHost = window.connectHost;
        const flagProvider = new (0, $5b38bdb59f96dd8e$export$b0063bae72b769ca)(flags);
        const messageProvider = new (0, $157238e938dfefde$export$a83e9a931c6e6660)(flags);
        const adaptor = connectHost.getFrameworkAdaptor();
        /**
				 * Subscribe to ACJS internal events for iframe performance and iframe timeout events
				 * Then use the analytics client from confluence to track those events.
				 */ try {
            connectHost.onIframePerformanceTelemetry((eventData)=>{
                (0, $9ecdd307d90af869$export$32b5fc7c31e23507).trackIframePerformanceTelemetry(eventData.extension, eventData.metrics);
            });
            connectHost.onIframeTimeout(async (eventData)=>{
                if (eventData.extension && (0, $e8b0a10921c7b2d5$export$c696ad8ee2dce236)(eventData.extension.id)) (0, $9ecdd307d90af869$export$32b5fc7c31e23507).trackIframeTimeout(eventData.extension);
                else (0, $9ecdd307d90af869$export$32b5fc7c31e23507).trackInvalidIframeTimeout(eventData.extension);
            });
            connectHost.onIframeEstablished(async (eventData)=>{
                (0, $9ecdd307d90af869$export$32b5fc7c31e23507).trackIframeLoaded(eventData.extension);
                (0, $9ecdd307d90af869$export$32b5fc7c31e23507).sendAppAnalyticsEvent(activationId, eventData.extension);
            });
            connectHost.onIframeVisible(async (eventData)=>{
                (0, $9ecdd307d90af869$export$32b5fc7c31e23507).trackIframeViewed(eventData.extension);
            });
            connectHost.onContentResolverEvent?.(async (eventData)=>{
                (0, $9ecdd307d90af869$export$32b5fc7c31e23507).trackContentResolverEvent(eventData);
            });
            connectHost?.onForwardAnalyticsEvent?.(async (eventType, eventData)=>{
                (0, $9ecdd307d90af869$export$32b5fc7c31e23507).handleForwardedAnalyticsEvent(eventType, eventData);
            });
        } catch (e) {}
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-test-id": "connect-support-component"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Ynul.FlagModule), {
            flagProvider: flagProvider,
            adaptor: adaptor
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Ynul.MessageModule), {
            messageProvider: messageProvider,
            adaptor: adaptor
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c3a4fd1273bb47ee$export$cac04457d61afcbc), {
            key: "ccanalytics",
            cloudId: cloudId,
            connectHost: connectHost
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $042d81536d760f84$export$5cf2450969d5ce3b), {
            key: "marketplace",
            cloudId: cloudId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8cOoD.DataProviderModule), {
            connectHost: connectHost
        }));
    });
};
const $824b1085c7d6a070$export$9123996dc48566a9 = (0, $7aRa9.withFlags)($824b1085c7d6a070$var$ConnectSupportComponent);
module.exports["ConnectSupport"] = $824b1085c7d6a070$export$9123996dc48566a9;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("80koo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cpjd2 = parcelRequire("cpjd2");

const $c65634971abef8c1$export$c2019f6d43c6c1ce = ({ wrm: wrm, children: children })=>{
    const [wrmLoadingState, setWrmLoadingState] = (0, $42omo.useState)({
        loaded: false,
        modules: []
    });
    (0, $42omo.useEffect)(()=>{
        (0, $cpjd2.requireLegacyWRM)(wrm, (modules)=>{
            setWrmLoadingState({
                loaded: true,
                modules: modules
            });
        }, ()=>{});
    }, [
        wrm
    ]);
    return wrmLoadingState.loaded && children ? children(wrmLoadingState.modules) : null;
};
module.exports["RequireLegacyWRM"] = $c65634971abef8c1$export$c2019f6d43c6c1ce;

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("fh4WQ", function(module, exports) {

var $9d5GH = parcelRequire("9d5GH");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b1ec481d92afa1cf$var$baseForOwn(object, iteratee) {
    return object && $9d5GH(object, iteratee, $d6TaN);
}
module.exports = $b1ec481d92afa1cf$var$baseForOwn;

});

parcelRegister("iawSg", function(module, exports) {

var $fh4WQ = parcelRequire("fh4WQ");


var $fKRi0 = parcelRequire("fKRi0");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $d3a2a94fdae59b54$var$baseEach = $fKRi0($fh4WQ);
module.exports = $d3a2a94fdae59b54$var$baseEach;

});

parcelRegister("fKRi0", function(module, exports) {

var $bRRFB = parcelRequire("bRRFB");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b7847d143ef17a3d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$bRRFB(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $b7847d143ef17a3d$var$createBaseEach;

});

parcelRegister("l6Xaz", function(module, exports) {

var $1MzfQ = parcelRequire("1MzfQ");

const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$893dc3b18722ac51(resource, asyncScript = false, asyncCss = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') {
        if (asyncCss) {
            const asyncAttributes = {
                ...attributes,
                media: 'print'
            };
            const linkId = `ac${(0, $1MzfQ.simpleHash)(resource.url)}`;
            return `<link id="${linkId}" rel="stylesheet" nonce="${nonce}" href="${resource.url}" fetchpriority="high"${$372ebd682f0fb003$export$a0d21c5c067fafcf(asyncAttributes)}/>\n` + // Use a separate inline script instead of onload because the onload attribute is blocked by CSP. While the script can have own nonce.
            `<script nonce="${nonce}">document.getElementById("${linkId}").onload=function(){this.media="all"}</script>`;
        }
        return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    } else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToTags"] = $372ebd682f0fb003$export$893dc3b18722ac51;

});

parcelRegister("1MzfQ", function(module, exports) {
function $957ef058f1d872b8$export$b211ce59c0ea1cfb(str) {
    let hash = 5381;
    for(let i = 0; i < str.length; i++)// Legit usage of bitwise operators
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) + hash + str.charCodeAt(i) >>> 0;
    return hash.toString(36);
}
module.exports["simpleHash"] = $957ef058f1d872b8$export$b211ce59c0ea1cfb;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("1wScy", function(module, exports) {

var $3PAnx = parcelRequire("3PAnx");


var $77wHb = parcelRequire("77wHb");

/** Used for built-in method references. */ var $11d2d2e303d6c19d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $11d2d2e303d6c19d$var$hasOwnProperty = $11d2d2e303d6c19d$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $11d2d2e303d6c19d$var$groupBy = $77wHb(function(result, value, key) {
    if ($11d2d2e303d6c19d$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $3PAnx(result, key, [
        value
    ]);
});
module.exports = $11d2d2e303d6c19d$var$groupBy;

});

parcelRegister("77wHb", function(module, exports) {

var $gETEr = parcelRequire("gETEr");


var $bSxMj = parcelRequire("bSxMj");


var $hWvFC = parcelRequire("hWvFC");


var $fZxmY = parcelRequire("fZxmY");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $52f28c800c0dec0e$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $fZxmY(collection) ? $gETEr : $bSxMj, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $hWvFC(iteratee, 2), accumulator);
    };
}
module.exports = $52f28c800c0dec0e$var$createAggregator;

});

parcelRegister("gETEr", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c20b8cf123ccbac3$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $c20b8cf123ccbac3$var$arrayAggregator;

});

parcelRegister("bSxMj", function(module, exports) {

var $iawSg = parcelRequire("iawSg");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $8a5ef07d195ea024$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $iawSg(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $8a5ef07d195ea024$var$baseAggregator;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("b363r", function(module, exports) {

var $bDniu = parcelRequire("bDniu");

function $80b4abd6bac4f47c$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $bDniu.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports["default"] = $80b4abd6bac4f47c$export$2e2bcd8739ae039;

});


//# sourceMappingURL=ConnectSupport.075e326d.js.map
